import { render, staticRenderFns } from "./PastProjectListView.vue?vue&type=template&id=2aaca504&"
import script from "./PastProjectListView.vue?vue&type=script&lang=ts&"
export * from "./PastProjectListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports